/**
 * The checkout form is filled on /checkout. The bank picker lives on the hosted
 * pay page (`/pay/{id}`), so these details are kept only to restore the form
 * if the customer comes back, and for the legacy `/checkout/payment-method` hop.
 */

export interface CheckoutCustomer {
  fullName: string;
  email: string;
  phone: string;
  company: string;
  address: {
    line1: string;
    line2: string;
    city: string;
    postalCode: string;
    country: string;
  };
}

export interface CheckoutDetails {
  tier: string;
  /** Custom plan only: the chosen price in euros, e.g. "25.00". */
  amount?: string;
  customer: CheckoutCustomer;
  /** A promo code the customer applied; checked again when the form is restored. */
  promoCode?: string;
  /** The customer ticked the 18+ and Terms box on the form. */
  acceptTerms?: boolean;
}

const KEY = "aistyle:checkout-details";

export function saveCheckoutDetails(details: CheckoutDetails): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(details));
  } catch {
    /* storage blocked — the picker sends the customer back to the form */
  }
}

export function loadCheckoutDetails(): CheckoutDetails | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as CheckoutDetails) : null;
  } catch {
    return null;
  }
}
